export function getBody(body: string | FormData): string | undefined {
  try {
    if (body instanceof FormData) {
      return JSON.stringify(Object.fromEntries(body));
    }
    return body;
  } catch {
    return undefined;
  }
}
